<template>
  <!-- eslint-disable-next-line vue/no-mutating-props -->
  <el-input v-model="formInline[item.key]"
    :placeholder="getValue(item, 'placeholder', placeholder)"
    type="text"
    :clearable="getValue(item, 'clearable', false)"
    :disabled="getValue(item, 'disabled', false)"
    :maxlength="
      getValue(item, 'maxlength', item.type === 'tel' ? 11 : defaultMaxLenght)
    "
    @blur="telBlur($event, item, '1')"
    @keyup.native="telBlur($event, item)"
    v-show="!item.showFn || item.showFn(formInline)"
    @clear="telBlur('', item)"
  >
    <template v-if="getValue(item, 'prepend', '')" slot="prepend">{{
      getValue(item, 'prepend', '')
    }}</template>
    <template v-if="getValue(item, 'append', '')" slot="append">{{
      getValue(item, 'append', '')
    }}</template>
  </el-input>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    formInline: {
      type: Object,
      default: () => ({}),
    },
  },
  inject: {
    defaultMaxLenght: 'defaultMaxLenght',
    colon: 'colon',
    customTypeList: 'customTypeList',
    getValue: 'getValue',
    placeholder: 'placeholder',
    selectPlaceholder: 'selectPlaceholder',
    customInputHandle: 'customInputHandle',
    telBlur: 'telBlur',
    numberMax: 'numberMax',
    changeSelect: 'changeSelect',
  },
  data() {
    return {}
  },
  watch: {},
}
</script>
